import type { TicketViewType } from '@interfaces/ticketevolution/tikets';
import { AlertTriangle, InfoCircle, Typography } from '@v2/ui';
import { cn, normalizeTicketNotes } from '@v2/utils';

interface TicketDisclosuresProps {
  publicNotes?: string | null;
  viewType?: TicketViewType | string | null;
  className?: string;
}

export function TicketDisclosures({
  publicNotes,
  viewType,
  className,
}: TicketDisclosuresProps) {
  const notes = normalizeTicketNotes(publicNotes) || null;
  const viewRestriction =
    viewType && String(viewType).trim().toLowerCase() !== 'full'
      ? viewType
      : null;

  if (!notes && !viewRestriction) {
    return null;
  }

  return (
    <div className={cn('space-y-2', className)}>
      {notes && (
        <div className="flex items-start gap-x-3 rounded-lg bg-gray-50 p-3">
          <InfoCircle
            aria-hidden="true"
            className="mt-0.5 shrink-0 text-gray-500"
            pathProps={{ stroke: 'currentColor' }}
            size="18"
          />
          <div className="min-w-0">
            <Typography
              variant="p"
              size="txs"
              className="font-semibold text-gray-800"
            >
              Ticket notes
            </Typography>
            <Typography
              size="tsm"
              className="whitespace-pre-wrap break-words text-gray-600"
            >
              {notes}
            </Typography>
          </div>
        </div>
      )}

      {viewRestriction && (
        <div
          className="flex items-start gap-x-3 rounded-lg border border-warning-700/20 bg-warning-100 p-3"
          role="alert"
        >
          <AlertTriangle
            aria-hidden="true"
            className="mt-0.5 shrink-0 text-warning-700"
            pathProps={{ stroke: 'currentColor' }}
            size="18"
          />
          <Typography size="tsm" className="break-words text-warning-700">
            <strong>View restriction:</strong> {viewRestriction}
          </Typography>
        </div>
      )}
    </div>
  );
}
